function getGroupScrollId(group) {
    return `assessment-group-${group.id}`;
}

export default getGroupScrollId;
